import { useSelector } from "react-redux";
import { FC } from "react";

import Image from "next/legacy/image";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { selectChainId } from "redux/slices/metamask";

import ClientOnly from "components/ClientOnly";
import CustomLink from "components/CustomLink";

import { useMarketplaceUrl } from "hooks/useMarketplaceUrl";

import { CHAIN_IDS } from "enums/chainIds";

import { ETHER_ADDRESS_O } from "config/addresses";

import { formatAccount, getChainById } from "utils/blockchain";

import WebExplorerLinksFactory from "services/blockchain/WebExplorerLinksFactory";

interface OwnerProps {
  tokenOwner: string;
  data: {
    metamaskAddress: string | null;
    nickname?: string;
  };
  contractName?: string;
  itemChainId: CHAIN_IDS | null;
  mintTransactionHash?: string;
}

const Owner: FC<OwnerProps> = ({
  tokenOwner,
  data,
  contractName,
  itemChainId,
  mintTransactionHash,
}) => {
  const chainId = useSelector(selectChainId);
  const marketplaceUrl = useMarketplaceUrl();
  const chain = getChainById(itemChainId);
  const tokenOwnerAddress =
    tokenOwner === ETHER_ADDRESS_O ? data.metamaskAddress : tokenOwner;

  return (
    <>
      <Box display="flex" flexWrap={"wrap"}>
        {chain && (
          <Box sx={{ width: { xs: "50%", lg: "25%" } }}>
            <Typography component="h4" variant="h4" gutterBottom>
              NETWORK
            </Typography>
            <Box display="flex">
              <Image src={chain.icon} width={25} height={25} />
              {mintTransactionHash && itemChainId ? (
                <CustomLink
                  href={WebExplorerLinksFactory.tx(
                    itemChainId,
                    mintTransactionHash,
                  )}
                  rel="noreferrer"
                  target="_blank"
                >
                  <Typography ml={0.5}>{chain.chain}</Typography>
                </CustomLink>
              ) : (
                <Typography ml={0.5}>{chain.chain}</Typography>
              )}
            </Box>
          </Box>
        )}
        <Box sx={{ width: { xs: "50%", lg: "25%" } }}>
          <Box display="flex" alignItems="center">
            <Typography component="h4" variant="h4" gutterBottom>
              OWNER
            </Typography>
          </Box>
          <Typography color="textPrimary">
            <ClientOnly>
              {tokenOwnerAddress ? (
                <CustomLink
                  href={WebExplorerLinksFactory.address(
                    itemChainId ?? chainId,
                    tokenOwnerAddress,
                  )}
                  rel="noreferrer"
                  target="_blank"
                >
                  {data.nickname
                    ? data.nickname
                    : formatAccount(tokenOwnerAddress)}
                </CustomLink>
              ) : null}
            </ClientOnly>
          </Typography>
        </Box>
        <Box
          sx={{ width: { xs: "50%", lg: "25%" }, marginTop: { xs: 2, lg: 0 } }}
        >
          {contractName && (
            <>
              <Typography component="h4" variant="h4" gutterBottom>
                COLLECTION
              </Typography>

              <Typography>
                <CustomLink href={marketplaceUrl}>{contractName}</CustomLink>
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Owner;
